import script from "./PaperUploadPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PaperUploadPanel.vue?vue&type=script&setup=true&lang=js"

import "./PaperUploadPanel.vue?vue&type=style&index=0&id=c53a585c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c53a585c"]])

export default __exports__